import { useQuery } from '@tanstack/react-query';
import type { YearlyMealPricePlanResponse } from '../../models/food/payments/yearly-meal-price-plan.dto';
import apiRequest from '../../services/apiWrapper';
import { FOOD_PAYMENTS } from '../../utils/constants/urlConstants';

async function getYearlyMenuPricePlan(startYear: number) {
  const response = await apiRequest.get<YearlyMealPricePlanResponse>(
    `${FOOD_PAYMENTS}/students/price-plan/yearly`,
    { params: { startYear } }
  );

  return response.data;
}

export function useGetYearlyMenuPricePlan(startYear: number) {
  return useQuery({
    queryKey: ['yearly-menu-price-plan', startYear],
    queryFn: () => getYearlyMenuPricePlan(startYear),
    enabled: Boolean(startYear > 0),
    staleTime: 2 * 60 * 1000,
  });
}
